/**
 * @Description: 标签图标信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  LabelIconModel,
  LabelIconViewModel,
  LabelIconSearchModel,
  LabelIconPageSearchModel,
  LabelIconAddModel,
  LabelIconUpdateModel,
  IdsModel
} from '@/model/product/LabelIconModel'

const baseUrl = Route.product + '/labelIcon'

/**
 * 搜索分页数据
 */
export const pageSearchLabelIcon = (param: LabelIconPageSearchModel) => {
  return https().request<RootObject<PageRespModel<LabelIconViewModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchLabelIcon = (param: LabelIconSearchModel) => {
  return https().request<RootObject<LabelIconModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getLabelIcon = (id: number) => {
  return https().request<RootObject<LabelIconModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addLabelIcon = (param: LabelIconAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateLabelIcon = (param: LabelIconUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeLabelIcon = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveLabelIcon = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
